'use client';

import { getHours } from 'date-fns';
import type { FC, PropsWithChildren } from 'react';
import { useEffect, useMemo, useState } from 'react';
import { useDataPopup } from '../hooks/useDataPopup';
import { useTruth } from '../hooks/useTruth';
import { messages } from '../messages';

interface ConditionTimeOfDayProps extends PropsWithChildren {
  morning?: string;
  noon?: string;
  evening?: string;
  night?: string;
}

export const ConditionTimeOfDay: FC<ConditionTimeOfDayProps> = ({
  morning,
  noon,
  evening,
  night,
}) => {
  const { dataBlocks } = useTruth();
  const { time, date, timezone } = dataBlocks;
  const { DataPopup } = useDataPopup();

  const [currentDate, setCurrentDate] = useState(new Date());

  const handle = useMemo(() => {
    const hourInADay = getHours(currentDate);

    if (hourInADay > 4 && hourInADay < 11) {
      return morning;
    } else if (hourInADay > 11 && hourInADay < 18) {
      return noon;
    } else if (hourInADay > 18 && hourInADay < 22) {
      return evening;
    } else {
      return night;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- branch props are static JSX; keyed on the date
  }, [currentDate]);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentDate(new Date());
    }, 30 * 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <DataPopup
      handle={handle}
      condition={{
        title: messages['condition.timeOfDay'],
        options: [
          {
            title: messages['condition.timeOfDay.morning'],
            value: morning,
          },
          {
            title: messages['condition.timeOfDay.noon'],
            value: noon,
          },
          {
            title: messages['condition.timeOfDay.evening'],
            value: evening,
          },
          {
            title: messages['condition.timeOfDay.night'],
            value: night,
          },
        ],
      }}
      dataBlocks={{ time, date, timezone }}
    />
  );
};
